import type { AnnouncementModel } from '@/types/models/AnnouncementModel'
import type { WidgetModel } from '@/types/models/WidgetModel'
import { computed, type ComputedRef } from 'vue'
import i18n from '../locales/i18n'
import { DEVICE_ROUTE, EVENTS_ROUTE } from '../router/routes'

export const mockupHomeAnnouncements: ComputedRef<AnnouncementModel[]> = computed(() => [
    {
        title: i18n.global.t('home.welcomeTitle'),
        content: i18n.global.t('home.welcomeContent'),
        closable: false,
        fullWidth: true
    }
])

export const mockupHomeWidgets: WidgetModel[] = [
    {
        title: "Données d'inventaire",
        content: [
            {
                label: "Total d'appareils",
                value: 20,
                link: DEVICE_ROUTE
            },
            {
                label: 'Appareils en stocks',
                value: 15,
                link: `${DEVICE_ROUTE}`
            },
            {
                label: 'Appareils en location',
                value: 5,
                link: `${DEVICE_ROUTE}`
            }
        ]
    },
    {
        title: 'Données de courses',
        content: [
            {
                label: 'Courses du jour',
                value: 2,
                link: `${DEVICE_ROUTE}`
            },
            {
                label: 'Courses à venir dans la semaine',
                value: 5,
                link: EVENTS_ROUTE
            },
            {
                label: 'Courses terminées le dernier weekend',
                value: 2,
                link: EVENTS_ROUTE
            }
        ]
    }
]
